import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

export default function BottomNav() {
  const [isCopied, setIsCopied] = useState(false);
  const whatsappLink = 'wa.me/966503083277';

  const handleCopy = () => {
    navigator.clipboard.writeText(whatsappLink);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-[0_-1px_3px_rgba(0,0,0,0.1)] safe-area-bottom">
      <div className="max-w-xl mx-auto px-3 py-2">
        <div className="flex items-center gap-2">
          <div className="flex-1 relative">
            <input
              type="text"
              value={whatsappLink}
              readOnly
              className="w-full px-3 py-2 bg-gray-50 rounded-lg text-gray-700 text-sm focus:outline-none"
            />
            <button
              onClick={handleCopy}
              className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 hover:bg-gray-100 rounded-md transition-colors"
              aria-label="Copy WhatsApp number"
            >
              {isCopied ? 
                <Check className="w-4 h-4 text-green-600" /> : 
                <Copy className="w-4 h-4 text-green-600" />
              }
            </button>
          </div>
          <a
            href={`https://${whatsappLink}`}
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 bg-green-600 text-white text-sm rounded-lg font-medium hover:bg-green-700 transition-colors whitespace-nowrap"
          >
            فتح واتساب
          </a>
        </div>
      </div>
    </div>
  );
}